module.exports = __webpack_public_path__ + "img/liberty-resort-black.8c3777af.png";